<template>
  <div>
    <nav-bar/>
    <div class="container-fluid page-padding">
      <div class="container-md">
        <div class="row">
          <div class="col-6">
            <h1>
              <span class="font18px primary-text px-5">پایگاه دانش</span>
            </h1>
          </div>
          <div class="col-6 text-left">
            <v-btn color="primary" outlined @click="openCategoryBox">
              دسته بندی
              <i class="fas fa-cubes mr-1 fa-xl"></i>
            </v-btn>
          </div>
          <div v-for="item in knowledgeBase" :key="item.KnowledgeId" class="col-sm-6 col-lg-4 ">
            <knowledge-base-card :item="item"/>
          </div>
        </div>
        <div id="categoryBox" class="category-box bg-white p-2">
          <div class="row rounded-lg align-items-center">
            <div class="col-auto">
              <v-btn icon @click="closeCategoryBox">
                <v-icon small class="primary-text">fas fa-times</v-icon>
              </v-btn>
            </div>
            <div class="col-auto">دسته بندی پایگاه دانش</div>
          </div>
          <div class="row mx-1">
            <div class="col-12 border-bottom">
              <router-link class="black--text" :to="{path:'knowledgeBaseClient'}">
                <span class="d-inline-block w-75"> همه </span>
                <span class="d-inline-block w-25 text-left"><i class="fas fa-arrow-alt-left"></i></span>
              </router-link>
            </div>
            <div v-for="item in categoryList" :key="item.KnowledgeCategoryId" class="col-12 border-bottom">
              <router-link class="black--text" :to="{path:'knowledgeBaseClient',query:{id:item.KnowledgeCategoryId}}">
                <span class="d-inline-block w-75">{{ item.Name }}</span>
                <span class="d-inline-block w-25 text-left"><i class="fas fa-arrow-alt-left pointer"></i></span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-overlay
        v-model="showLoaderDialog"
        persistent
        width="500">
      <v-progress-circular
          color="white"
          indeterminate
          size="50"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import NavBar from "@/Ticketing/components/navBar";
import KnowledgeBaseCard from "@/Ticketing/components/knowledgeBaseCard";

export default {
  name: "knowledgeBaseClient",
  components: {KnowledgeBaseCard, NavBar},
  metaInfo() {
    return {
      title: 'تیکتینگ-پایگاه دانش '
    }
  },
  data: () => ({
    showLoaderDialog: false,
    knowledgeBase: [],
    categoryList: [],
  }),
  mounted() {
    this.getKnowledgeItems()
    this.getCategory()
  },
  watch: {
    '$route.query.id'() {
      location.reload()
    }
  },

  methods: {
    openCategoryBox() {
      document.getElementById('categoryBox').classList.add('open')
    },
    closeCategoryBox() {
      document.getElementById('categoryBox').classList.remove('open')

    },
    getKnowledgeItems() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };
      let query = "";
      if (this.$route.query.id !== undefined) {
        console.log(this.$route.query.id)
        query = "?categoryId=" + this.$route.query.id
        console.log(query)
      }

      fetch(this.$baseUrl + "/Client/GetKnowledgeItems" + query, requestOptions)
          .then(response => response.text())
          .then(result => {
            this.knowledgeBase = JSON.parse(result)
            console.log(this.knowledgeBase)
            this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    },
    getCategory() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/GetKnowledgeCategories", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.categoryList = JSON.parse(result)
            this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>

<style scoped>

</style>